import "core-js/modules/es6.array.map";
import _toConsumableArray from "/home/runner/work/ass/ass/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.replace";
import { assign } from '../utils.js';
function createCommand(arr) {
  var cmd = {
    type: null,
    prev: null,
    next: null,
    points: []
  };
  if (/[mnlbs]/.test(arr[0])) {
    cmd.type = arr[0].toUpperCase().replace('N', 'L').replace('B', 'C');
  }
  for (var len = arr.length - !(arr.length & 1), i = 1; i < len; i += 2) {
    cmd.points.push({
      x: arr[i] * 1,
      y: arr[i + 1] * 1
    });
  }
  return cmd;
}
function isValid(cmd) {
  if (!cmd.points.length || !cmd.type) {
    return false;
  }
  if (/C|S/.test(cmd.type) && cmd.points.length < 3) {
    return false;
  }
  return true;
}
function getViewBox(commands) {
  var _ref;
  var minX = Infinity;
  var minY = Infinity;
  var maxX = -Infinity;
  var maxY = -Infinity;
  (_ref = []).concat.apply(_ref, _toConsumableArray(commands.map(function (_ref2) {
    var points = _ref2.points;
    return points;
  }))).forEach(function (_ref3) {
    var x = _ref3.x,
      y = _ref3.y;
    minX = Math.min(minX, x);
    minY = Math.min(minY, y);
    maxX = Math.max(maxX, x);
    maxY = Math.max(maxY, y);
  });
  return {
    minX: minX,
    minY: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}

/**
 * Convert S command to B command
 * Reference from https://github.com/d3/d3/blob/v3.5.17/src/svg/line.js#L259
 * @param  {Array}  points points
 * @param  {String} prev   type of previous command
 * @param  {String} next   type of next command
 * @return {Array}         converted commands
 */
export function s2b(points, prev, next) {
  var results = [];
  var bb1 = [0, 2 / 3, 1 / 3, 0];
  var bb2 = [0, 1 / 3, 2 / 3, 0];
  var bb3 = [0, 1 / 6, 2 / 3, 1 / 6];
  var dot4 = function dot4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
  };
  var px = [points[points.length - 1].x, points[0].x, points[1].x, points[2].x];
  var py = [points[points.length - 1].y, points[0].y, points[1].y, points[2].y];
  results.push({
    type: prev === 'M' ? 'M' : 'L',
    points: [{
      x: dot4(bb3, px),
      y: dot4(bb3, py)
    }]
  });
  for (var i = 3; i < points.length; i++) {
    px = [points[i - 3].x, points[i - 2].x, points[i - 1].x, points[i].x];
    py = [points[i - 3].y, points[i - 2].y, points[i - 1].y, points[i].y];
    results.push({
      type: 'C',
      points: [{
        x: dot4(bb1, px),
        y: dot4(bb1, py)
      }, {
        x: dot4(bb2, px),
        y: dot4(bb2, py)
      }, {
        x: dot4(bb3, px),
        y: dot4(bb3, py)
      }]
    });
  }
  if (next === 'L' || next === 'C') {
    var last = points[points.length - 1];
    results.push({
      type: 'L',
      points: [{
        x: last.x,
        y: last.y
      }]
    });
  }
  return results;
}
export function toSVGPath(instructions) {
  return instructions.map(function (_ref4) {
    var type = _ref4.type,
      points = _ref4.points;
    return type + points.map(function (_ref5) {
      var x = _ref5.x,
        y = _ref5.y;
      return "".concat(x, ",").concat(y);
    }).join(',');
  }).join('');
}
export function compileDrawing(rawCommands) {
  var _ref7;
  var commands = [];
  var i = 0;
  while (i < rawCommands.length) {
    var arr = rawCommands[i];
    var cmd = createCommand(arr);
    if (isValid(cmd)) {
      if (cmd.type === 'S') {
        var _points$slice$ = (commands[i - 1] || {
            points: [{
              x: 0,
              y: 0
            }]
          }).points.slice(-1)[0],
          x = _points$slice$.x,
          y = _points$slice$.y;
        cmd.points.unshift({
          x: x,
          y: y
        });
      }
      if (i) {
        cmd.prev = commands[i - 1].type;
        commands[i - 1].next = cmd.type;
      }
      commands.push(cmd);
      i++;
    } else {
      if (i && commands[i - 1].type === 'S') {
        var additionPoints = {
          p: cmd.points,
          c: commands[i - 1].points.slice(0, 3)
        };
        commands[i - 1].points = commands[i - 1].points.concat((additionPoints[arr[0]] || []).map(function (_ref6) {
          var x = _ref6.x,
            y = _ref6.y;
          return {
            x: x,
            y: y
          };
        }));
      }
      rawCommands.splice(i, 1);
    }
  }
  var instructions = (_ref7 = []).concat.apply(_ref7, _toConsumableArray(commands.map(function (_ref8) {
    var type = _ref8.type,
      points = _ref8.points,
      prev = _ref8.prev,
      next = _ref8.next;
    return type === 'S' ? s2b(points, prev, next) : {
      type: type,
      points: points
    };
  })));
  return assign({
    instructions: instructions,
    d: toSVGPath(instructions)
  }, getViewBox(commands));
}